import styled from 'styled-components';
import { Stack } from 'components/Stack';

export const PickUpLocationContainer = styled(Stack).attrs({
  direction: 'column',
  gap: 8,
})`
  padding: 16px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;

export const Info = styled.div`
  font-size: 16px;
  line-height: 19px;
`;
